import { Injectable } from '@angular/core';

import { LogService } from '@oa/shared-core';

@Injectable()
export class CoatCheckService {
  private readonly _serviceName = 'CoatCheckService';

  private _dict = new Map<string, any>();

  constructor(private log: LogService) {}

  public get verboseLogging(): boolean {
    return this.log.verboseLogging;
  }

  /**
   * Adds an object to the Coat Check and returns a string that is the "ticket" to retrieve the object.
   */
  public add(data: any) {
    if (!data) {
      return null;
    }

    const uuid = this.generateUUID();

    console.log(`${this._serviceName} add. uuid=${uuid}`);

    this._dict.set(uuid, data);

    console.log(`${this._serviceName}().add uuid=${uuid}`);

    return uuid;
  }

  // used to re-create a value after an auth redirect
  public addSpecific(data: any, ticket: string) {
    if (!data) {
      return null;
    }

    if (!ticket) {
      return null;
    }

    console.log(`${this._serviceName} addSpecific. ticket=${ticket}`);

    this._dict.set(ticket, data);

    console.log(`${this._serviceName}().addSpecific ticket=${ticket}`);

    return ticket;
  }

  /**
   * Gets the data for the ticket
   * @param ticket
   */
  public get(ticket: string) {
    if (!ticket) {
      return null;
    }

    console.log(`${this._serviceName} get. ticket=${ticket}`);

    let data = this._dict.get(ticket);

    return data;
  }

  /**
   * Removes an item from the Coat Check
   * @param ticket
   */
  public remove(ticket: string) {
    console.log(`${this._serviceName} remove. ticket=${ticket}`);

    this._dict.delete(ticket);
  }

  /**
   * Prints the data dictionary to the console (admin log only)
   */
  public print() {
    console.log(`${this._serviceName} print this._dict`, this._dict);
  }

  private generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
}
